// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"s_u","closeButtonDark":"s_w","closeButtonWhite":"s_y"};